import {CommonModule} from '@angular/common';
import {NavigationListComponent} from 'apps/faculty/src/app/components/navigation-list/navigation-list.component';
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {NavigationItemsEnum} from '../../../enums/navigation-items.enum';

@Component({
    imports: [CommonModule, NavigationListComponent],
    selector: 'app-primary-sidebar',
    templateUrl: './primary-sidebar.component.html',
    styleUrls: ['./primary-sidebar.component.scss']
})
export class PrimarySidebarComponent {
    @Output() collapseClicked = new EventEmitter();
    @Input() hideNavLinks = false;
    constructor() {}

    navItemClicked(item: NavigationItemsEnum) {
        if (item === NavigationItemsEnum.Collapse) {
            this.collapseClicked.emit();
        }
    }
}
